import { FC, useEffect, useState } from "react";
import { WarrantyItemForDamaged } from "../../../types";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { Box, Typography } from "@mui/material";
import SkeletonList from "../../../pages/SpareParts/HomePage/SkeletonList/SkeletonList";
import { DialogContainer, StyledInputBox } from "./DamagedAndBrokenParts.style";
import { ShipToAddress } from "../OrderOffer/ShiptToAddress";
import { InvoicesAddress } from "../OrderOffer/InvoicesAddress";
import PartialShipment from "../OrderOffer/PartialShipment";
import OrderOfferNote from "../OrderOffer/OrderOfferNote";
import WarrantyBasketItemsHeader from "../WarrantyBasketItemsHeader";
import WarrantyBasketItems from "../WarrantyBasketItems";
import { OfferOrderReference } from "../OrderOffer/OfferOrderReference";
import DeliveryDate from "../OrderOffer/DeliveryDate";
import useBrands from "../../../../explorer/hooks/useBrands";
import { SalesConditionsDTO } from "../../../../explorer/types/OrderOffer/SalesConditions";
import ServiceProvider from "../../../configuration/ServiceProvider";
import { SalesCondition } from "../OrderOffer/SaleCondition";
import ConfirmButton from "../../AppButtons/ConfirmButton";
import { SellConditionsContainer } from "../OrderOffer/OrderOfferNotification.style";
import CircleButton from "../../AppButtons/CircleButton";
import { AppIconsDocumentChecked } from "../../AppIcons";

type TDamagedAndBrokenPartsSummary = {
    items: WarrantyItemForDamaged[];
    loading: boolean;
    formFields: {
        deliveryAddress: string;
        invoiceAddress: string;
        partialShipment: boolean;
        note: string;
        deliveryDate: string;
        ponReference: string;
        noteItems: {};
        hasAgreement: boolean;
        cgvAgreement:boolean,
       
    };
    createChangeValueHandler: (
        key:
            | "note"
            | "ponReference"
            | "deliveryAddress"
            | "partialShipment"
            | "deliveryDate"
            | "invoiceAddress"
            | "noteItems"
            | "hasAgreement"
            | "cgvAgreement"
    ) => (e: any, value: any) => void;
    createChangeHandler: (
        key:
            | "note"
            | "ponReference"
            | "deliveryAddress"
            | "partialShipment"
            | "deliveryDate"
            | "invoiceAddress"
            | "noteItems"
            | "hasAgreement"
            | "cgvAgreement"
    ) => (e: any, value: any) => void;
};

const DamagedAndBrokenPartsSummary: FC<TDamagedAndBrokenPartsSummary> = (
    props
) => {
    const {
        items,
        loading,
        formFields,
        createChangeValueHandler,
        createChangeHandler,
    } = props;
    const { t } = useTranslation();
    const brand = useBrands().currentBrandUrl;

    const [openSalesCondition, setOpenSalesCondition] = useState(false);
    const [salesConditions, setSalesConditions] =
        useState<SalesConditionsDTO | null>(null);

     const getSalesCondition = () => {
        setOpenSalesCondition(!openSalesCondition);
        if (!openSalesCondition) {
          ServiceProvider.OrderOffer.salesConditions(brand)
            .then((result) => {
              setSalesConditions(result);
            })
            .catch((e) => console.error(e));
        }
      };
    
   
     useEffect(() => {
         getSalesCondition()
     },[]);
    return (
        <Box
            sx={{
                minWidth: 650,
                gap: "10px",
                display: "flex",
                flexDirection: "column",
                maxHeight: 400,
            }}
            aria-label="simple table"
        >
            <Box sx={{ display: "flex", flexDirection: "row", flex: 1 }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        " > div:first-of-type p":{
                            paddingTop:0,
                        }
                    }}
                >
                    <ShipToAddress
                        onSelectChange={createChangeValueHandler(
                            "deliveryAddress"
                        )}
                    />
                    <InvoicesAddress />
                    <OfferOrderReference
                        isOffer={false}
                        value={formFields.ponReference}
                        onChange={createChangeHandler("ponReference")}
                        offerReferenceValid={false}
                        onChangeOfferReferenceValid={() => {}}
                    />
                    <PartialShipment
                        defaultValue={false}
                        onChange={createChangeHandler("partialShipment")}
                    />
                    <DeliveryDate
                        onChangeDeliveryDateValid={(value: boolean) => {}}
                        onChange={createChangeValueHandler("deliveryDate")}
                    />
                </Box>
                <Box sx={{ display: "flex", flex: 1, flexDirection: "column", paddingLeft: '30px', }}>
                <SellConditionsContainer>
                          <Typography>{t("common.salesCondition")}</Typography>
                          <AppIconsDocumentChecked sx={{marginLeft:"7px"}}/>

                      </SellConditionsContainer>

                      <SalesCondition
                          open={openSalesCondition}
                          salesConditions={salesConditions}
                      />
                
                </Box>
            </Box>
            <OrderOfferNote
                value={formFields.note}
                onChange={createChangeHandler("note")}
            />
            {loading ? (
                <SkeletonList
                    mkey="MissingPartsWrongMaterialSummary"
                    cols={6}
                    rowsForCell={2}
                    hasHeader
                />
            ) : (
                <>
                    <DialogContainer>
                        <WarrantyBasketItemsHeader />
                    </DialogContainer>
                    {items.map((item: WarrantyItemForDamaged, idx: number) => (
                        <WarrantyBasketItems
                            item={item}
                            key={`${idx}_${item.code}_${item.navContext}`} readOnly={true}                        >
                            <Box sx={{ display: "flex", gap: '25px', paddingTop: '7px', }}>
                                <StyledInputBox>
                                    <Typography id="defect" sx={{fontSize: '14px', textTransform: 'uppercase',}}>
                                        {t("warranty.defect")}
                                    </Typography>
                                    <Box  sx={{fontSize: '14px',}}>
                                        {t(`warranty.${item.damageType}`)}
                                    </Box>
                                </StyledInputBox>

                                <StyledInputBox>
                                    <Typography id="scrappedMaterialSite"  sx={{fontSize: '14px', textTransform: 'uppercase',}}>
                                        {t("warranty.scrappedMaterialSite")}
                                    </Typography>
                                    <Box sx={{ width: 90, fontSize: '14px', }}>
                                        {t(
                                            item.scrappedMaterialOnSite
                                                ? "common.yes"
                                                : "common.no"
                                        )}
                                    </Box>
                                </StyledInputBox>

                                <StyledInputBox>
                                    <Typography id="priority"  sx={{fontSize: '14px', textTransform: 'uppercase',}}>
                                        {t("warranty.priority")}
                                    </Typography>
                                    <Box  sx={{fontSize: '14px',}}>{t(`warranty.${item.priority}`)}</Box>
                                </StyledInputBox>
                            </Box>
                        </WarrantyBasketItems>
                    ))}
                </>
            )}
        </Box>
    );
};

export default DamagedAndBrokenPartsSummary;
